import React from 'react'
import { Edit } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import FoodPackageForm from './FoodPackageForm'

const FoodPackageEdit: React.FC = () => {
  return (
    <SectionWrapper title={'resources.foodpackages.editPackage'}>
      <Edit>
        <FoodPackageForm />
      </Edit>
    </SectionWrapper>
  )
}

export default FoodPackageEdit
